import { render } from "./CertificatesView.vue?vue&type=template&id=d3f2d09e&scoped=true&ts=true"
import script from "./CertificatesView.vue?vue&type=script&lang=ts"
export * from "./CertificatesView.vue?vue&type=script&lang=ts"

import "./CertificatesView.vue?vue&type=style&index=0&id=d3f2d09e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f2d09e"]])

export default __exports__